import dashSocialIconBlack from '@/assets/dashsocial/dash-social-icon-black.svg';
import dashSocialIconPrimary from '@/assets/dashsocial/dash-social-icon-primary.svg';
import dashSocialIconWhite from '@/assets/dashsocial/dash-social-icon-white.svg';
import dashSocialLogoBlack from '@/assets/dashsocial/dash-social-logo-black.svg';
import dashSocialLogoPrimaryBlack from '@/assets/dashsocial/dash-social-logo-primary-black.svg';
import dashSocialLogoPrimaryWhite from '@/assets/dashsocial/dash-social-logo-primary-white.svg';
import dashSocialLogoWhite from '@/assets/dashsocial/dash-social-logo-white.svg';

export const brandingDashSocial = {
  appName: 'Dash Social',
  abbreviated: 'Dash',

  logoPrimary: dashSocialLogoPrimaryBlack,
  iconPrimary: dashSocialIconPrimary,
  iconPlaceholder: dashSocialIconPrimary,

  // These are alternate variants of the branding that are currently unused
  logoPrimaryWhite: dashSocialLogoPrimaryWhite,
  logoBlack: dashSocialLogoBlack,
  logoWhite: dashSocialLogoWhite,

  iconBlack: dashSocialIconBlack,
  iconWhite: dashSocialIconWhite,
};
